import * as React from 'react'

import * as styles from './itemThumbnailCarousel.module.css'

const ItemThumbnailCarousel = ({ children }: { children: any }) => {
  return (
    <div className={styles.itemListWrapper}>
      <ul className={styles.itemListContainer}>
        {React.Children.map(children, child => {
          return <li className={styles.itemList}>{child}</li>
        })}
      </ul>
    </div>
  )
}

export default ItemThumbnailCarousel



// WEBPACK FOOTER //
// ./client/pages/home/itemThumbnailCarousel/itemThumbnailCarousel.tsx